import type { KapselLage } from "../../kern/kapsel";
import { useLineup } from "./lineup";

/** Zahl der Acts am Reiter „Line-up“ (Kapsel-Register, Paket E3). Klein, damit der Reiter selbst erst beim Öffnen lädt. */
export function LineupZahl({ lage }: { lage: KapselLage }) {
  const q = useLineup(lage.vorhabenId);
  return q.data ? q.data.length : null;
}
